<template>

	<div class="inner success">
		<div class="content-box small">
			<div class="container">
				<div class="icon">
					<svg xmlns="http://www.w3.org/2000/svg" width="175" height="175" viewBox="0 0 200 200">
					  <circle fill="#2fc07d" cx="100" cy="100" r="100"/>
					  <path fill="#fff" d="M1485.43,947.177l-52.93,53.273a6.066,6.066,0,0,1-8.1,0l-20.84-20.986a5.4,5.4,0,0,1,0-7.61,5.32,5.32,0,0,1,7.56,0l17.33,17.449,49.42-49.737a5.322,5.322,0,0,1,7.56,0A5.4,5.4,0,0,1,1485.43,947.177Z" transform="translate(-1345 -870)"/>
					</svg>
				</div>
				<div v-if="style == 'screening'">
					<h1>{{$t('screening.receipt.headline')}}</h1>
					<p class="text">{{$t('screening.receipt.text')}}</p>
					<router-link to="/screenings" class="button purple" >{{$t('screening.receipt.button')}}</router-link>
				</div>
				<!-- <div v-if="style == 'subscription'">
					Subscription receipt
				</div>
				<div v-if="style == 'contract'">
					Contract receipt
				</div> -->
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		data: () => ({
			style: ''
		}),
		created() {
			this.style = this.$route.params.style;
		}
	}
</script>
